import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../components/shared/header/Header";
import Footer from "../../components/shared/footer/Footer";
import Breadcrumb from "../../components/shared/breadcrumb/Breadcrumb";
import { STATIC_SERVER_URL, PRODUCT_SIZES, REDEMPTION_FEE } from "../../config/config";
import AnalyticsService from "../../services/analytics";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { authorizedState, loginModalState } from "atoms/atoms";
import useCart from "hooks/Cart";

import "./cart.scss";

const Cart = () => {
  const {
    basket,
    removeFromBasket,
    updateQuantity,
    getTotalPrice,
    getRedemptionFee,
    clearBasket
  } = useCart();

  const setLoginModalState = useSetRecoilState(loginModalState);
  const authorized = useRecoilValue(authorizedState);
  const navigate = useNavigate();

  React.useEffect(() => {
    AnalyticsService.sendPageView(window.location.pathname);
  }, []);

  const handleCheckoutButtonClick = () => {
    if (authorized) {
      navigate("/penztar");
    } else {
      setLoginModalState({
        isVisible: true,
        redirectAfterLogin: "/penztar"
      });
    }
  };

  const handleQuantityChange = (itemNo, size, newQuantity) => {
    updateQuantity(itemNo, size, parseInt(newQuantity) || 1);
  };

  return (
    <div>
      <Header />
      <Breadcrumb />
      <section className="main-content basket-details__container container">
        <div className="row">
          <div className="col-12">
            <h2 className="h2">Kosár</h2>
          </div>

          {basket.length > 0 ? (
            <>
              <div className="col-sm-12 col-lg-8">
                <table className="table basket-details__table show-desktop">
                  <thead>
                    <tr>
                      <th colSpan="2">Termék</th>
                      <th>Mennyiség</th>
                      <th>Ár</th>
                      <th>Összesen</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    {basket.map((item) => (
                      <tr key={`${item.item_no}-${item.size}`}>
                        <td>
                          <img
                            src={`${STATIC_SERVER_URL}/web/images/shop/products/${item.item_no}_001.png`}
                            alt={item.name}
                            onError={(e) => {
                              e.target.src = `${STATIC_SERVER_URL}/web/images/shop/products/default.png`;
                            }}
                          />
                        </td>
                        <td className="product-detail">
                          <strong>{item.name}</strong>
                          {!!item.size && (
                            <p>
                              Méret: <input
                                className="form-control"
                                type="text"
                                readOnly
                                value={PRODUCT_SIZES[item.size]}
                              />
                            </p>
                          )}
                        </td>
                        <td>
                          <input
                            className="form-control"
                            type="number"
                            min="1"
                            value={item.quantity}
                            onChange={(e) => handleQuantityChange(item.item_no, item.size, e.target.value)}
                          />
                        </td>
                        <td>
                          {!item.discount_price && (
                            <span>{item.price.toLocaleString()} Ft</span>
                          )}
                          {!!item.discount_price && (
                            <>
                              <span>{item.discount_price.toLocaleString()} Ft</span>
                              <p className="original-price">Eredeti ár: {item.price.toLocaleString()} Ft</p>
                            </>
                          )}
                          {!!item.redemption_fee && (
                            <p><strong>+{REDEMPTION_FEE * item.quantity} Ft<sup>*</sup></strong></p>
                          )}
                        </td>
                        <td>
                          {!!item.discount_price && (
                            <>{(item.discount_price * item.quantity + (item.redemption_fee ? REDEMPTION_FEE * item.quantity : 0)).toLocaleString()} Ft</>
                          )}
                          {!item.discount_price && (
                            <>{(item.price * item.quantity + (item.redemption_fee ? REDEMPTION_FEE * item.quantity : 0)).toLocaleString()} Ft</>
                          )}
                        </td>
                        <td>
                          <button
                            className="btn-remove-basket-item"
                            title="Törlés"
                            onClick={() => removeFromBasket(item.item_no, item.size)}
                          >
                            <svg
                              fill="none"
                              viewBox="0 0 14 16"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="m13.5 2.5h-2.5938l-1.06245-1.75c-.25-.40625-.8125-.75-1.28125-.75h-3.15625c-.46875 0-1.03125.34375-1.28125.75l-1.0625 1.75h-2.5625c-.28125 0-.5.25-.5.5v.5c0 .28125.21875.5.5.5h.5l.65625 10.5938c.03125.7812.71875 1.4062 1.5 1.4062h7.65625c.7813 0 1.4687-.625 1.5-1.4062l.6875-10.5938h.5c.25 0 .5-.21875.5-.5v-.5c0-.25-.25-.5-.5-.5zm-8.09375-1h3.15625l.59375 1h-4.34375zm5.40625 13h-7.65625l-.65625-10.5h8.9688z"
                                fill="#e36464"
                              />
                            </svg>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <p>* visszaváltási díj, összesen</p>
              </div>
              <div className="col-sm-12 col-lg-4">
                <div className="checkout-box">
                  <h3>Összegzés</h3>
                  <h4>Rendelés összértéke <span>{(getTotalPrice() + getRedemptionFee()).toLocaleString()} Ft</span></h4>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleCheckoutButtonClick}
                  >
                    megrendelés
                  </button>
                  <Link className="btn btn-secondary" to="/">
                    tovább vásárolok
                  </Link>
                  <p>A megrendelés oldalon számlázási és szállítási adataidat adhatod meg.</p>
                </div>
              </div>
            </>
          ) : (
            <div className="col-12">
              <p className="text-center">A kosaradban nincsenek termékek.</p>
            </div>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Cart;
